import {
  Box,
  Button,
  Container,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";

const CreateBusiness = () => {
  const [formData, setFormData] = useState({
    display_name: "",
    email: "",
    company: "",
    contact: "",
    timezone: "Asia/Calcutta GMT+05:30",
    currency: "INR",
    companySize: "",
    password: "",
  });
  const [creating, setCreating] = useState(false);

  const companySizes = [
    "1 - 10",
    "10 - 20",
    "20 - 50",
    "50 - 100",
    "100 - 500",
    "500+",
  ];

  const currencies = [
    { value: "INR", label: "Indian Rupee (INR)" },
    { value: "USD", label: "US Dollar (USD)" },
    { value: "EUR", label: "Euro (EUR)" },
    { value: "GBP", label: "British Pound (GBP)" },
  ];

  const timezones = [
    {
      value: "Asia/Calcutta GMT+05:30",
      label: "India (Asia/Calcutta GMT+05:30)",
    },
    {
      value: "America/New_York GMT-05:00",
      label: "Eastern Time (America/New_York GMT-05:00)",
    },
    {
      value: "America/Chicago GMT-06:00",
      label: "Central Time (America/Chicago GMT-06:00)",
    },
    {
      value: "America/Los_Angeles GMT-08:00",
      label: "Pacific Time (America/Los_Angeles GMT-08:00)",
    },
    {
      value: "Europe/London GMT+00:00",
      label: "London (Europe/London GMT+00:00)",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setCreating(true);
      const response = await axios.post(
        `${API_ENDPOINT}/partner/create-business`,
        formData,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } catch (error) {
      toastError(error);
    } finally {
      setCreating(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Create Business Profile</PageTitle>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          p: 4,
          borderRadius: 2,
          boxShadow: 1,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Business Information
        </Typography>

        <TextField
          size="small"
          fullWidth
          margin="normal"
          label="Display Name"
          name="display_name"
          value={formData.display_name}
          onChange={handleChange}
          required
        />

        <TextField
          size="small"
          fullWidth
          margin="normal"
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <TextField
          size="small"
          fullWidth
          margin="normal"
          label="Company Name"
          name="company"
          value={formData.company}
          onChange={handleChange}
          required
        />

        <TextField
          size="small"
          fullWidth
          margin="normal"
          label="Contact Number"
          name="contact"
          value={formData.contact}
          onChange={handleChange}
          required
          inputProps={{ pattern: "[0-9]{10,15}" }}
          helperText="Enter phone number with country code (e.g., 918116856153)"
        />

        <TextField
          size="small"
          fullWidth
          margin="normal"
          select
          label="Timezone"
          name="timezone"
          value={formData.timezone}
          onChange={handleChange}
          required
        >
          {timezones.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="small"
          fullWidth
          margin="normal"
          select
          label="Currency"
          name="currency"
          value={formData.currency}
          onChange={handleChange}
          required
        >
          {currencies.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="small"
          fullWidth
          margin="normal"
          select
          label="Company Size"
          name="companySize"
          value={formData.companySize}
          onChange={handleChange}
          required
        >
          {companySizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="small"
          fullWidth
          margin="normal"
          label="Password"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          inputProps={{ minLength: 8 }}
          helperText="Password must be at least 8 characters long"
        />

        <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
          <Button type="submit" variant="contained" size="large" sx={{ px: 4 }}>
            Create Business
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default CreateBusiness;
